var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isWide)?[_c('RainWideLayer',{attrs:{"boundsList":_vm.boundsList}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }